const $                     = require('jquery');
const _                     = require('underscore');
const { icon }              = require('@fortawesome/fontawesome-svg-core');
const tippy                 = require('tippy.js/dist/tippy-bundle.umd.js')
const metrics               = require('../util/metrics');
const status                = require('../util/status');
const ensureImg             = require('../util/ensure_img');
const online                = require('../ctrl/online');
const sidepanel             = require('../ctrl/sidepanel');
const svgIcons              = require('../icons/svg_icons');
const menu                  = require('./sidenav');
const fcr                   = require('./fcr');
const citedby               = require('./citedby');

const faIconOpts = { classes: ['fa-icon icon-h-20'] };
const fa = {
  chartLine: require('@fortawesome/pro-light-svg-icons/faChartLine').definition,
  angleRight: require('@fortawesome/pro-light-svg-icons/faAngleRight').definition
};

class Metrics {
  constructor({ container, metadata, syncApi }) {
    if (!metadata.doi) return;

    this._meta = metadata;
    this._container = container;
    this._syncApi = syncApi;
    this._elem = $(`
      <div class="content wrfont metrics">
        <div class="badge-container"></div>
      </div>
    `);

    metrics({ doi: metadata.doi, syncApi }).then(data => {
      if (data.count) {
        menu.add({
          id: 'metrics',
          icon: fa.chartLine,
          title: 'Metrics',
          badge: data.count,
          render: _.memoize(() => this._render(data))
        });
      }
    }).catch(() => {});
  }

  _render(data) {
    if (data.altmetric?.score) {
      tippy($(`
        <a class="badge altmetric"
          data-tippy-content="View on altmetric.com"
          href="${altmetricBadgeUrl({ data: data.altmetric, metadata: this._meta })}" target="_blank">
          <div class="badge-img-bg"></div>
          <img src="${data.altmetric.images.large}" alt/>
          <div class="label">Altmetric</div>
        </a>
      `).appendTo(this._elem.find('.badge-container'))[0]);
    } else {
      this._elem.addClass('no-altmetric');
    }

    if (data.dimensions?.times_cited) {
      tippy($(`
        <a class="badge dimensions"
          data-tippy-content="View on dimensions.ai"
          href="${dimensionsBadgeUrl({ metadata: this._meta })}" target="_blank">
          <div class="badge-img-bg"></div>
          <img src="${dimensionsBadgeSrc({ count: data.dimensions.times_cited, size: 220 })}" alt/>
          <div class="label">Dimensions</div>
        </a>
      `).appendTo(this._elem.find('.badge-container'))[0]);

      const title = {
        online: 'View full list of citations',
        offline: 'You need to be online to view the full list of citations'
      };

      const citedByOptions = () => ({
        id: 'citedby',
        title: `Citations (${data.dimensions.times_cited})`,
        content: citedby.render({
          metadata: this._meta,
          syncApi: this._syncApi
        })
      });
      const citations = $(`
        <div class="metrics-btn" data-tippy-content="${title.online}">
          <i class="icon citations">${svgIcons.metrics_citations}</i>
          <div class="count">${data.dimensions.times_cited}</div>
          <div class="label">Citations</div>
          ${icon(fa.angleRight, faIconOpts).html}
        </div>
      `).click(online.guard(() => {
        sidepanel.open(citedByOptions());
      })).appendTo(this._elem);

      tippy(citations[0], {
        placement: 'bottom',
        maxWidth: '220px'
      });

      status.on('online', () => {
        citations.removeClass('disabled');
        citations[0].title = title.online;
        this._elem.find('img[src]').each((idx, img) => ensureImg(img));
      });
      status.on('offline', () => {
        citations.addClass('disabled');
        citations[0].title = title.offline;
      });

      if (sidepanel.lastOpenId === 'citedby') {
        sidepanel.open(citedByOptions());
      }
    }

    if (data.dimensions?.recent_citations) {
      const recent = $(`
        <div class="metrics-btn disabled"
          data-tippy-content="The number of citations in the last two years">
          <i class="icon recent-citations">${svgIcons.metrics_recent_citations}</i>
          <div class="count">${data.dimensions.recent_citations}</div>
          <div class="label">Recent citations</div>
        </div>
      `).appendTo(this._elem);

      tippy(recent[0], { placement: 'bottom', maxWidth: '220px' });
    }

    if (data.dimensions?.field_citation_ratio) {
      const fcrOptions = () => ({
        id: 'fcr',
        title: 'FCR',
        content: fcr.render(data.dimensions.field_citation_ratio)
      });
      const fcrBtn = $(`
        <div class="metrics-btn" data-tippy-content="Click for more information">
          <i class="icon fcr">${svgIcons.metrics_fcr}</i>
          <div class="count">${data.dimensions.field_citation_ratio.toFixed(2)}</div>
          <div class="label">Field Citation Ratio</div>
          ${icon(fa.angleRight, faIconOpts).html}
        </div>
      `).click(() => {
        sidepanel.open(fcrOptions());
      }).appendTo(this._elem);

      tippy(fcrBtn[0], { placement: 'bottom' });
    }

    return this._elem.appendTo(this._container);
  }
}

function dimensionsBadgeSrc({ count, size }) {
  return `https://badge.dimensions.ai/badge?count=${count}&size=${size}&background=fill`
}

function dimensionsBadgeUrl({ metadata }) {
  return `https://badge.dimensions.ai/details/id/${metadata.meta.dimensions_id}`;
}

function altmetricBadgeUrl({ data, metadata }) {
  let publisher = metadata.publisher;
  if (publisher == 'ats') publisher = 'atsjournals';
  return `https://papersenterprise.altmetric.com/details/${data.altmetric_id}`;
}

module.exports = Metrics;
